import { render } from "./OrderEdoDocumentsTab.vue?vue&type=template&id=2dec43e0&scoped=true"
import script from "./OrderEdoDocumentsTab.vue?vue&type=script&lang=js"
export * from "./OrderEdoDocumentsTab.vue?vue&type=script&lang=js"

import "./OrderEdoDocumentsTab.vue?vue&type=style&index=0&id=2dec43e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dec43e0"]])

export default __exports__